import { useStore } from "vuex";
import { onBeforeUnmount, onMounted } from "vue";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("useVuexSideEffect");

export function useVuexSideEffect(effects: Record<string, (state: unknown) => void>) {
    const store = useStore();
    const effectEntries = Object.entries(effects);

    let unsubscribe: () => void | undefined;

    onMounted(() => {
        unsubscribe = store.subscribe((mutation, state) => {
            // fre action when mutation is triggered, passing current Store state
            const [mutationType, sideEffectToFire] =
                effectEntries.find(([action]) => action === mutation.type) || [];
            if (sideEffectToFire) {
                logger.trace(
                    `Firing side effect of mutation "${mutationType}" | effect body:\n${sideEffectToFire}`
                );
                sideEffectToFire(state);
            }
        });
    });
    onBeforeUnmount(() => {
        // unsubscribe from store when component is unmounted
        unsubscribe?.();
    });
}
